var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"page-wrap DeviceList-page"},[_c('Search',{ref:"search",attrs:{"label":_vm.searchLabel},on:{"search":_vm.search}}),_c('List',{ref:"list",attrs:{"title":"绑定设备列表","refresh":true,"label":_vm.label,"apiName":"petDeviceList"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }